import React from 'react'
import { connect } from 'react-redux'
import { findEntity, getEntity } from '../services/'
import { getCurrentUserId } from '../services/session/'
import {
  isCommInProgress,
  getCommunicationState,
  COMM_STATES
} from '../modules/communication'
import Loading from '../ui/views/loading'
import Error from '../ui/views/error'

export default function withEntity(WrappedComponent) {
  const EntityContainer = class extends React.Component {
    componentDidMount() {
      const { entity, findEntity, id, domain, isLoading } = this.props
      if (!entity && !isLoading && id) {
        findEntity(domain, id)
      }
    }
    render() {
      const { entity, commState, ...rest } = this.props
      switch (commState) {
        case COMM_STATES.NotAsked:
          return entity ? (
            <WrappedComponent entity={entity} {...rest} />
          ) : (
            <Loading />
          )
        case COMM_STATES.Loading:
          return <Loading />
        case COMM_STATES.Success:
          return <WrappedComponent entity={entity} {...rest} />
        default:
          return <Error />
      }
    }
  }
  function mapStateToProps(state, props) {
    const id = props.id || props.match.params.id
    const commResource = `${props.domain}:${id}`
    return {
      id,
      userId: getCurrentUserId(state),
      entity: getEntity(props.domain, id, state),
      isLoading: isCommInProgress(commResource, state),
      commState: getCommunicationState(commResource, state)
    }
  }
  return connect(mapStateToProps, { findEntity })(EntityContainer)
}



// WEBPACK FOOTER //
// ./src/context/with-entity.js